import { render, staticRenderFns } from "./PersonDialog.vue?vue&type=template&id=59a92abc&scoped=true"
import script from "./PersonDialog.vue?vue&type=script&lang=js"
export * from "./PersonDialog.vue?vue&type=script&lang=js"
import style0 from "./PersonDialog.vue?vue&type=style&index=0&id=59a92abc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a92abc",
  null
  
)

export default component.exports